import {
  createRequestTypes,
  createActions,
  REQUEST,
  SUCCESS,
  FAILURE,
} from "./index";

export const INVOICES = createRequestTypes("INVOICES");
export const invoice = {
  request: (filter) => createActions(INVOICES[REQUEST], filter),
  success: (data) => createActions(INVOICES[SUCCESS], data),
  failure: (error) => createActions(INVOICES[FAILURE], error),
};
